export default __webpack_public_path__ + "static/media/gasoline-pump.6d239f35.svg";